import { render } from "./ComparadorProducto.vue?vue&type=template&id=892924de&scoped=true"
import script from "./ComparadorProducto.vue?vue&type=script&lang=js"
export * from "./ComparadorProducto.vue?vue&type=script&lang=js"

import "./ComparadorProducto.vue?vue&type=style&index=0&id=892924de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-892924de"]])

export default __exports__